import { Action, createReducer, on } from '@ngrx/store';
import { Statistics } from '../../../models/statistics';
import * as statisticsActions from '../statistics/statistics.actions';

export interface StatisticsState {
  loadingStatistics: number;
  statistics: Statistics;
  statusApi: boolean;
  statusDashboard: boolean;
  statusAndroid: boolean;
  statusApple: boolean;
}

export const initialStatisticsState: StatisticsState = {
  loadingStatistics: 0,
  statistics: null,
  statusApi: false,
  statusDashboard: false,
  statusAndroid: false,
  statusApple: false,
};

export const reducer = createReducer(
  initialStatisticsState,
  on(statisticsActions.getStatisticsSuccess, (state, { statistics }) => {
    return {
      ...state,
      statistics,
      loadingStatistics: state.loadingStatistics + 1,
    };
  }),
  on(statisticsActions.getStatisticsError, (state) => {
    return {
      ...state,
      loadingStatistics: state.loadingStatistics - 1,
    };
  }),
  on(statisticsActions.getStatusApiSuccess, (state) => {
    return {
      ...state,
      loadingStatistics: state.loadingStatistics + 1,
      statusApi: true,
    };
  }),
  on(statisticsActions.getStatusApiError, (state) => {
    return {
      ...state,
      loadingStatistics: state.loadingStatistics - 1,
      statusApi: false,
    };
  }),
  on(statisticsActions.getStatusDashboardSuccess, (state) => {
    return {
      ...state,
      loadingStatistics: state.loadingStatistics + 1,
      statusDashboard: true,
    };
  }),
  on(statisticsActions.getStatusDashboardError, (state) => {
    return {
      ...state,
      loadingStatistics: state.loadingStatistics - 1,
      statusDashboard: false,
    };
  }),
  on(statisticsActions.getStatusAndroidSuccess, (state) => {
    return {
      ...state,
      loadingStatistics: state.loadingStatistics + 1,
      statusAndroid: true,
    };
  }),
  on(statisticsActions.getStatusAndroidError, (state) => {
    return {
      ...state,
      loadingStatistics: state.loadingStatistics - 1,
      statusAndroid: false,
    };
  }),
  on(statisticsActions.getStatusAppleSuccess, (state) => {
    return {
      ...state,
      loadingStatistics: state.loadingStatistics + 1,
      statusApple: true,
    };
  }),
  on(statisticsActions.getStatusAppleError, (state) => {
    return {
      ...state,
      loadingStatistics: state.loadingStatistics - 1,
      statusApple: false,
    };
  })
);

export function statisticsReducer(state: StatisticsState | undefined, action: Action) {
  return reducer(state, action);
}
